import React, { useEffect } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { get_banners, add_banner_click_activity } from '../store/reducers/homeReducer';

const CustomLeftArrow = ({ onClick }) => (
  <button
    onClick={onClick}
    className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-gray-200 rounded-full p-2"
    style={{ zIndex: 0 }}
  >
    &#10094;
  </button>
);

const CustomRightArrow = ({ onClick }) => (
  <button
    onClick={onClick}
    className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-gray-200 rounded-full p-2"
    style={{ zIndex: 0 }}
  >
    &#10095;
  </button>
);

const Banner = () => {
  // Three banners
  const under1300 = ['/images/banner/8.webp'];
  const under2000 = ['/images/banner/9.webp'];
  const under5000 = ['/images/banner/10.webp'];

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // If user is logged in, we track banner clicks
  const { userInfo } = useSelector((state) => state.auth) || {};

  // We read the store’s price range from Redux
  const { priceRange } = useSelector((state) => state.home);
  // If not loaded, fallback to [0..999999]
  const storeLow = priceRange?.low ?? 0;

  useEffect(() => {
    dispatch(get_banners());
  }, [dispatch]);

  // Banner “intended” max values
  const bannerMapping = {
    under1300: 1300,
    under2000: 2000,
    under5000: 5000
  };

  // On banner click:
  // 1) If user is logged in, dispatch banner_click_activity
  // 2) Use storeLow as "low"
  // 3) Use the banner’s intended max for "high"
  // 4) Navigate to /shops
  const handleBannerClick = (bannerCategory) => {
    if (userInfo) {
      dispatch(
        add_banner_click_activity({
          userId: userInfo.id,
          userName: userInfo.name,
          bannerCategory
        })
      );
    }
    const intendedHigh = bannerMapping[bannerCategory];
    navigate(`/shops?low=${storeLow}&high=${intendedHigh}`);
  };

  const responsive = {
    superLargeDesktop: { breakpoint: { max: 4000, min: 3000 }, items: 1 },
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 1 },
    tablet: { breakpoint: { max: 1024, min: 464 }, items: 1 },
    mobile: { breakpoint: { max: 464, min: 0 }, items: 1 }
  };

  return (
    <div className="w-full pt-4">
      <div className="w-[85%] lg:w-[90%] mx-auto relative">
        <div className="w-full flex flex-wrap gap-8">
          <div className="w-full">
            <div className="my-8 relative">
              <Carousel
                autoPlay
                infinite
                arrows
                showDots
                responsive={responsive}
                customLeftArrow={<CustomLeftArrow />}
                customRightArrow={<CustomRightArrow />}
              >
                {under1300.map((img, i) => (
                  <div
                    key={i}
                    onClick={() => handleBannerClick('under1300')}
                    className="cursor-pointer"
                  >
                    <img src={img} alt={`Under 1300 - Image ${i}`} />
                  </div>
                ))}

                {under2000.map((img, i) => (
                  <div
                    key={i}
                    onClick={() => handleBannerClick('under2000')}
                    className="cursor-pointer"
                  >
                    <img src={img} alt={`Under 2000 - Image ${i}`} />
                  </div>
                ))}

                {under5000.map((img, i) => (
                  <div
                    key={i}
                    onClick={() => handleBannerClick('under5000')}
                    className="cursor-pointer"
                  >
                    <img src={img} alt={`Under 5000 - Image ${i}`} />
                  </div>
                ))}
              </Carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
